import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import DemographicDetail from './DemographicDetail';

class DemographicsSinglePersona extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const detailsGroupsList = [];
    let demographicsInfo = [];
    if (this.props.demographics !== undefined) {
      demographicsInfo = this.props.demographics;
      _.each(_.chunk(this.props.demographics[0].detailGroups, 6), splitList => {
        detailsGroupsList.push(splitList);
      });
    }
    return (
      <div className="row fullwidth demoCardPdf">
        <div className="large-1 medium-1 small-1 columns">
          <span>&nbsp;</span>
        </div>
        <div
          className="large-10 medium-10 small-10 columns"
          id="demographicsSinglePersonaPdf"
        >
          {!_.isEmpty(demographicsInfo) && detailsGroupsList.length > 0 && (
            <div>
              <div>
                {detailsGroupsList.map((splitList, i) => (
                  <div
                    className="row demographic-detail-columns fullwidth"
                    key={`demo-s-top${i}`}
                  >
                    {splitList.map((demoDetail, j) => (
                      <div
                        className="columns large-2 small-2 medium-2"
                        key={`demo-s-end${i}${j}`}
                      >
                          <DemographicDetail
                            key={demoDetail.name}
                            demoDetail={demoDetail}
                            personaIndex={0}
                            selectedTab={this.props.selectedTab}
                          />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="large-1 medium-1 small-1 columns">
          <span>&nbsp;</span>
        </div>
      </div>
    );
  }
}

DemographicsSinglePersona.propTypes = {
  selectedTab: PropTypes.string,
  demographics: PropTypes.shape({})
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(DemographicsSinglePersona);
